import Vue from 'vue';
import moment from 'moment';

Vue.filter('date', (date, formatStr = 'YYYY-MM-DD') => moment(date).format(formatStr));

Vue.filter('week', (date) => {
  const n = moment(date).day();
  return `星期${'日一二三四五六'[n]}`;
});


Vue.filter('price', (price, type = 'full') => {
  if (!price && price !== 0) return; 
  const str = (price / 100).toFixed(2);
  const priceList = str.split('.');
  if (type === 'integer') {
    // 只要整数部分
    return priceList[0];
  } else if (type === 'decimal') {
    // 只要小数部分
    return `.${priceList[1]}`;
  }
  return str;
});




// WEBPACK FOOTER //
// ./src/libs/filter.js